module.exports = __webpack_public_path__ + "static/opengraph-816aeb5d70ca7c452fe2679db1f9efba.png";